// extracted by mini-css-extract-plugin
export default {"registration":"Home_registration__S-ZUR"};